import React from 'react'
import qs from 'qs'

import LoadingSpinner from '../../components/atoms/LoadingSpinner'

import {
  getStoredAccount,
  setStoredAccount,
  useAccounts
} from '../../providers/AccountProvider'
import { useEnvironment } from '../../providers/EnvironmentProvider'
import NoPermission from '../../components/molecules/NoPermission'

const AccountURLSwitch = ({ onValid }) => {
  const { loaded: accountsLoaded, accounts } = useAccounts()
  const { reload, afterLoadRef } = useEnvironment()
  const [noPerm, setNoPerm] = React.useState(false)

  // Switches account if needed, causes 404 for invalid accounts
  React.useEffect(() => {
    if (!accountsLoaded) {
      return
    }

    const { search } = window.location
    const params = qs.parse(search, {
      ignoreQueryPrefix: true
    })
    const newAccount = params._a

    if (!accounts.find(acc => acc.id === newAccount)) {
      setNoPerm(true)
      return
    }

    const currentAccount = getStoredAccount()

    // No switch needed
    if (currentAccount === newAccount) {
      onValid()
      return
    }

    // Perform account switch
    localStorage.setItem('session_switch', newAccount)
    setStoredAccount(newAccount)

    // Called after account switch happens
    afterLoadRef.current = () => {
      setTimeout(() => {
        localStorage.removeItem('session_switch')
        onValid()
      }, 200)
    }

    // Reloads environment and updates account
    reload()
  }, [accountsLoaded, accounts, reload, onValid, afterLoadRef])
  if (noPerm) {
    return <NoPermission />
  }
  return <LoadingSpinner />
}

export default AccountURLSwitch
